import { Brand, CustomerMark } from './Brand';
import { useSession } from '../state/SessionContext';

const LINKS: { hash: string; label: string; admin?: boolean }[] = [
  { hash: '#/', label: 'Dashboard' },
  { hash: '#/map', label: 'Farm map' },
  { hash: '#/block', label: '1,000-acre block' },
  { hash: '#/site3d', label: 'Site 3D' },
  { hash: '#/farmers', label: 'Farmers' },
  { hash: '#/admin', label: 'Admin', admin: true },
];

export function TopNav({ route }: { route: string }): JSX.Element {
  const { account, signOut } = useSession();
  const active = (hash: string): boolean => (hash === '#/' ? route === '#/' || route === '' || route === '#' : route.startsWith(hash));
  return (
    <header className="nav">
      <Brand />
      <span className="nav__sep" />
      <CustomerMark />
      <nav className="nav__links">
        {LINKS.filter((l) => !l.admin || account?.admin).map((l) => (
          <a key={l.hash} href={l.hash} className={active(l.hash) ? 'is-active' : ''}>
            {l.label}
          </a>
        ))}
      </nav>
      <div className="nav__end">
        <span className="nav__who" title={account?.email}>{account?.name}{account?.admin ? ' · admin' : ''}</span>
        <button type="button" className="btn-ghost" onClick={signOut}>Sign out</button>
      </div>
    </header>
  );
}
